"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserInstagramAccount = exports.isUserFacebookAccount = exports.UserRole = void 0;
const socialMedia_1 = require("./fabric/socialMedia");
/**
 * User role stored as cognito group to User Pool
 */
var UserRole;
(function (UserRole) {
    UserRole["user"] = "user";
    UserRole["admin"] = "admin";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
exports.isUserFacebookAccount = (item) => (item === null || item === void 0 ? void 0 : item.platform) === socialMedia_1.SocialMediaPlatform.facebook;
exports.isUserInstagramAccount = (item) => (item === null || item === void 0 ? void 0 : item.platform) === socialMedia_1.SocialMediaPlatform.instagram;
//# sourceMappingURL=users.js.map